import React from 'react';
import { Wifi, Settings } from 'lucide-react';
import PageBreadcrumb from '../common/PageBreadcrumb';
import PageHeader from '../common/PageHeader';

const PWAConfiguration = () => {
  return (
    <>
      <PageBreadcrumb />
      <PageHeader 
        title="PWA Configuration"
        description="Configure Progressive Web App settings for mobile access"
      />
      <div className="page-container">

        <div className="card-cam" style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', padding: '48px 24px' }}>
            <div style={{
              width: '80px',
              height: '80px',
              borderRadius: 'var(--component-radius)',
              background: 'var(--primary-light)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
              color: 'var(--primary-color)'
            }}>
              <Wifi size={48} />
            </div>
            <h2 style={{
              fontSize: '24px',
              fontWeight: '600',
              color: 'var(--text-heading)',
              margin: '0 0 16px 0',
              fontFamily: 'var(--font-family)'
            }}>PWA Settings</h2>
            <p style={{
              color: 'var(--text-body)',
              margin: '0 0 32px 0',
              maxWidth: '600px',
              marginLeft: 'auto',
              marginRight: 'auto',
              fontFamily: 'var(--font-family)'
            }}>
              Configure Progressive Web App settings for optimal mobile experience. 
              This feature will be available in v2.0.
            </p>
            
            <div style={{
              background: '#FEF3C7',
              border: '1px solid #FCD34D',
              borderRadius: 'var(--component-radius)',
              padding: '16px',
              marginBottom: '24px',
              maxWidth: '600px',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}>
              <p style={{
                color: '#92400E',
                fontSize: '14px',
                margin: 0,
                fontFamily: 'var(--font-family)'
              }}>
                <strong>Coming Soon:</strong> PWA configuration with offline capabilities, 
                push notifications, and mobile-optimized interface.
              </p>
            </div>

            <button className="btn-cam" style={{ margin: '0 auto' }}>
              <Settings size={20} style={{ marginRight: '8px' }} />
              Configure PWA
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PWAConfiguration;
